import { CoursesActionTypes } from './types';

export const getAllCourses = (pageNumber, pageSize, organisationId) => ({
  type: CoursesActionTypes.GET_ALL_COURSES,
  data: { pageNumber, pageSize, organisationId },
});

export const getAllCourseSuccess = (payload) => ({
  type: CoursesActionTypes.GET_ALL_COURSES_SUCCESS,
  payload,
});

export const getAllCourseFailure = (payload) => ({
  type: CoursesActionTypes.GET_ALL_COURSES_FAILED,
  payload,
});
export const getCourse = (pageNumber, pageSize) => ({
  type: CoursesActionTypes.GET_COURSES,
  data: { pageNumber, pageSize },
});
export const searchCourse = (searchPattern, pageSize) => ({
  type: CoursesActionTypes.SEARCH_COURSE,
  data: { searchPattern, pageSize },
});
export const searchByStatus = (status, pageNumber, pageSize, orgId) => ({
  type: CoursesActionTypes.FILTER_BY_STATUS,
  data: { status, pageNumber, pageSize, orgId },
});
export const searchByAdminLevel = (adminLevelItemId, pageSize) => ({
  type: CoursesActionTypes.FILTER_BY_ADMIN_LEVEL,
  data: { adminLevelItemId, pageSize },
});
export const searchCourseResult = (payload) => ({
  type: CoursesActionTypes.SEARCH_COURSE_RESULTS,
  payload,
});
export const getCourseDetails = (id, callBack) => ({
  type: CoursesActionTypes.GET_COURSE_DETAILS,
  data: { id, callBack },
});

export const getCourseDetailsSuccess = (payload) => ({
  type: CoursesActionTypes.GET_COURSE_DETAILS_SUCCESS,
  payload,
});

export const getCourseDetailsFailed = (payload) => ({
  type: CoursesActionTypes.GET_COURSE_DETAILS_FAILED,
  payload,
});

export const getCourseApplicants = (id) => ({
  type: CoursesActionTypes.GET_COURSES_APLLICANTS,
  data: { id },
});

export const getCourseApplicantsSuccess = (payload) => ({
  type: CoursesActionTypes.GET_COURSES_APLLICANTS_SUCCESS,
  payload,
});

export const getCourseApplicantsFailed = (payload) => ({
  type: CoursesActionTypes.GET_COURSES_APLLICANTS_FAILED,
  payload,
});

export const setCourse = (payload) => ({
  type: CoursesActionTypes.GET_COURSES_SUCCESS,
  payload,
});

export const setCourseSuccess = (payload) => ({
  type: CoursesActionTypes.ADD_COURSE_SUCCESS,
  payload,
});

export const setAddCourseFailed = (payload) => ({
  type: CoursesActionTypes.ADD_COURSE_FAILED,
  payload,
});

export const setCourseFailed = (payload) => ({
  type: CoursesActionTypes.GET_COURSES_FAILED,
  payload,
});

export const updateCourse = (payload, callBack) => ({
  type: CoursesActionTypes.UPDATE_COURSE,
  data: { payload, callBack },
});

export const disableCourse = (payload, cb) => ({
  type: CoursesActionTypes.DISABLES_COURSE,
  data: { payload, cb },
});

export const updateCourseSuccess = (payload) => ({
  type: CoursesActionTypes.UPDATE_COURSE_SUCCESS,
  payload,
});

export const updateCourseFailed = (payload) => ({
  type: CoursesActionTypes.UPDATE_COURSE_FAILED,
  payload,
});

export const setError = (payload) => ({
  type: CoursesActionTypes.ADD_FAILED,
  payload,
});

export const setDeleteError = (payload) => ({
  type: CoursesActionTypes.DELETE_COURSE_FAILED,
  payload,
});

export const setDeleteSuccess = (payload) => ({
  type: CoursesActionTypes.DELETE_COURSE_SUCCESS,
  payload,
});

export const courseAdded = (formData, callBack) => ({
  type: CoursesActionTypes.ADD_COURSE,
  data: { formData, callBack },
});

export const setCurrent = (course) => ({
  type: CoursesActionTypes.SET_CURRENT,
  payload: course,
});

export const setStatus = (payload) => ({
  type: CoursesActionTypes.SET_STATUS,
  payload,
});

export const clearStatus = () => ({
  type: CoursesActionTypes.CLEAR_STATUS,
});

export const clearError = () => ({
  type: CoursesActionTypes.CLEAR_ERROR,
});

export const clearCurrent = () => ({
  type: CoursesActionTypes.CLEAR_CURRENT,
});

export const deleteCourse = (payload, callBack) => ({
  type: CoursesActionTypes.DELETE_COURSE,
  data: { payload, callBack },
});

export const downloadCourseTemplate = () => ({
  type: CoursesActionTypes.DOWNLOAD_COURSE_TEMPLATE,
});

export const downloadCourseTemplateSuccess = () => ({
  type: CoursesActionTypes.DOWNLOAD_COURSE_TEMPLATE_SUCCESS,
});

export const downloadCourseTemplateFailure = () => ({
  type: CoursesActionTypes.DOWNLOAD_COURSE_TEMPLATE_FAILURE,
});

export const bulkCourseUpload = (data, callBack1, callBack2) => ({
  type: CoursesActionTypes.BULK_COURSES_UPLOAD,
  payload: { data, callBack1, callBack2 },
});

export const bulkCourseUploadSuccess = () => ({
  type: CoursesActionTypes.BULK_COURSES_UPLOAD_SUCCESS,
});

export const bulkCourseUploadFailure = (data) => ({
  type: CoursesActionTypes.BULK_COURSES_UPLOAD_FAILURE,
  payload: data,
});
